"use client"

import { useEffect, useState } from "react"

type Heading = { id: string; text: string; level: number }

export default function TableOfContents({ content: _content }: { content: unknown }) {
  const [headings, setHeadings] = useState<Heading[]>([])
  const [activeId, setActiveId] = useState("")
  const [hoverId, setHoverId] = useState("")

  useEffect(() => {
    const elements = document.querySelectorAll("article h2, article h3")
    const items: Heading[] = []
    elements.forEach((el) => {
      if (el.hasAttribute("data-toc-exclude")) return
      if (!el.id) el.id = el.textContent?.toLowerCase().replace(/[^a-z0-9]+/g, "-") || ""
      items.push({ id: el.id, text: el.textContent || "", level: parseInt(el.tagName[1]) })
    })
    setHeadings(items)
  }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => { if (entry.isIntersecting) setActiveId(entry.target.id) }),
      { rootMargin: "0px 0px -60% 0px" }
    )
    document.querySelectorAll("article h2, article h3").forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [headings])

  if (!headings.length) return null

  return (
    <div className="border-l-2 border-zinc-300 pl-4">
    <h3 className="text-sm font-semibold text-zinc-900 tracking-wide mb-4">Table of contents</h3>
    <ul className="space-y-2">
      {headings.map((heading) => (
        <li key={heading.id} style={{ paddingLeft: heading.level === 3 ? "12px" : "0px" }}>
          <a href={"#" + heading.id} className="block text-sm transition-colors" style={{ color: activeId === heading.id ? "#5841D8" : hoverId === heading.id ? "#5841D8" : "#52525b", fontWeight: activeId === heading.id || hoverId === heading.id ? "600" : "400" }} onMouseEnter={() => setHoverId(heading.id)} onMouseLeave={() => setHoverId("")}>{heading.text}</a>
        </li>
      ))}
    </ul>
  </div>
  )
}
